var _defs, _rect, _rect2, _rect3, _ellipse, _g, _rect4, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiBitScrewdriver1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steel",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c6cfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "steelDark",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4a545c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c333a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a201b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copper",
    x1: 0,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6c79b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d9853f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96501a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copperEdge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b06428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3c295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d4a16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brass",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0dfa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c8a83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d7420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lcd",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fb37c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shellWhite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eef1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#eef6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe8d9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spot",
    cx: 0.5,
    cy: 0.42,
    r: 0.62
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 60,
    height: 60,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60 0 L 0 0 0 60",
    fill: "none",
    stroke: "#628141",
    strokeOpacity: 0.06,
    strokeWidth: 1.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#spot)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 720,
    rx: 270,
    ry: 46,
    fill: "#1B211A",
    opacity: 0.13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 470) scale(0.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -236,
    width: 80,
    height: 250,
    rx: 26,
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -22.7,
    y1: -224,
    x2: -22.7,
    y2: 2,
    stroke: "#20301c",
    strokeOpacity: 0.35,
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3,
    y1: -224,
    x2: -11.3,
    y2: 2,
    stroke: "#20301c",
    strokeOpacity: 0.35,
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -224,
    x2: 0,
    y2: 2,
    stroke: "#20301c",
    strokeOpacity: 0.35,
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3,
    y1: -224,
    x2: 11.3,
    y2: 2,
    stroke: "#20301c",
    strokeOpacity: 0.35,
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.7,
    y1: -224,
    x2: 22.7,
    y2: 2,
    stroke: "#20301c",
    strokeOpacity: 0.35,
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -46,
    y: -248,
    width: 92,
    height: 34,
    rx: 16,
    fill: "#2b332c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: 10,
    width: 32,
    height: 150,
    rx: 6,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16,160 h32 l-6,54 h-20 z",
    fill: "url(#steelDark)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: -16,
    width: 176,
    height: 216,
    rx: 20,
    fill: "#2b332c",
    transform: "rotate(12 160 92)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 160 92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 8,
    width: 34,
    height: 46,
    rx: 7,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 16,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#39423a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 160 92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 8,
    width: 34,
    height: 46,
    rx: 7,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 16,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#39423a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 160 92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 72,
    width: 34,
    height: 46,
    rx: 7,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 80,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#39423a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 160 92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 72,
    width: 34,
    height: 46,
    rx: 7,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 80,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#39423a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 160 92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 136,
    width: 34,
    height: 46,
    rx: 7,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 144,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#39423a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 160 92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 136,
    width: 34,
    height: 46,
    rx: 7,
    fill: "url(#steel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 144,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#39423a"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 135,
    height: 44,
    rx: 22,
    fill: "#628141"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 77,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 21,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 2.1
  }, "Taparia")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 854,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#1B211A",
    fillOpacity: 0.55,
    textAnchor: "start",
    letterSpacing: 1.04
  }, "Multi-bit Screwdriver")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBitScrewdriver1);
export default __webpack_public_path__ + "static/media/multi-bit-screwdriver-1.b82823cead533b46ea27e732636cfc58.svg";
export { ForwardRef as ReactComponent };